/**
 * Loading Screen Animation
 * Shows a black screen with logo and loading bar animation
 */

class LoadingScreen {
  constructor() {
    this.loadingScreen = document.querySelector('.loading-screen');
    this.loadingDuration = 2800; // Total animation duration in milliseconds

    if (this.loadingScreen) {
      this.init();
    }
  }

  init() {
    // Add loading class to body to prevent scrolling
    document.body.classList.add('loading-active');

    // Start the hide sequence after animation completes
    setTimeout(() => {
      this.hideLoadingScreen();
    }, this.loadingDuration);
  }

  hideLoadingScreen() {
    if (this.loadingScreen) {
      // Add fade-out class to trigger CSS transition
      this.loadingScreen.classList.add('fade-out');

      // Remove loading screen from DOM after transition completes
      setTimeout(() => {
        document.body.classList.remove('loading-active');
        if (this.loadingScreen && this.loadingScreen.parentNode) {
          this.loadingScreen.parentNode.removeChild(this.loadingScreen);
        }

        // Trigger hero section animation after loading screen is removed
        this.triggerHeroAnimation();
      }, 500); // Match this with CSS transition duration
    }
  }

  triggerHeroAnimation() {
    const heroSections = document.querySelectorAll('.angarah-hero, .angarah-brand-tagline');
    heroSections.forEach((hero) => {
      hero.classList.add('hero-loaded');
    });
  }
}

// Initialize loading screen when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LoadingScreen();
  });
} else {
  new LoadingScreen();
}
